import Config from "../../../Configs";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export class PdfService extends ApiServiceBase {
  constructor(client: IHttpService) {
    super(client);
  }

  generatePdf(data: any) {
    const payload = {
      PdfString: JSON.stringify(data),
    };

    return this._client.post<string>(Config.apiPaths.generatePdf, payload);
  }
}
